const today = new Date();
today.setHours(0, 0, 0, 0);

const dayOffset = (days, hour, minute = 0) => {
  const d = new Date(today.getTime());
  d.setDate(d.getDate() + days);
  d.setHours(hour, minute, 0, 0);
  return d.toISOString();
};

export const MOCK_TABLES = [
  { id: 11, name: 'A-01', zone: 'Main Hall', seat_capacity: 4,  state: 'available' },
  { id: 12, name: 'A-02', zone: 'Main Hall', seat_capacity: 4,  state: 'available' },
  { id: 13, name: 'A-03', zone: 'Main Hall', seat_capacity: 4,  state: 'occupied'  },
  { id: 14, name: 'B-01', zone: 'Outdoor',   seat_capacity: 6,  state: 'available' },
  { id: 15, name: 'B-02', zone: 'Outdoor',   seat_capacity: 6,  state: 'reserved'  },
  { id: 16, name: 'V-01', zone: 'VIP',       seat_capacity: 8,  state: 'available' },
  { id: 17, name: 'V-02', zone: 'VIP',       seat_capacity: 10, state: 'available' },
  { id: 18, name: 'G-01', zone: 'Garden',    seat_capacity: 4,  state: 'available' }
];

export const RESERVATION_STATES = [
  { value: 'pending',   label: 'Pending',   color: 'warning', icon: 'fa-solid fa-hourglass-half' },
  { value: 'arrived',   label: 'Arrived',   color: 'success', icon: 'fa-solid fa-utensils'      },
  { value: 'cancelled', label: 'Cancelled', color: 'danger',  icon: 'fa-solid fa-ban'           }
];

export const MOCK_RESERVATIONS = [
  {
    id: 1,
    name: 'Somchai Jaidee',
    telephone: '081-234-5678',
    table_id: 15,
    pax: 4,
    reserve_at: dayOffset(0, 18, 30),
    state: 'pending',
    note: 'Window seat preferred',
    customer_id: null,
    created_at: dayOffset(-1, 10, 15)
  },
  {
    id: 2,
    name: 'Anna Carter',
    telephone: '089-111-2222',
    table_id: null,
    pax: 2,
    reserve_at: dayOffset(0, 19, 0),
    state: 'pending',
    note: 'Anniversary dinner — please prepare a small dessert',
    customer_id: 21,
    created_at: dayOffset(0, 9, 45)
  },
  {
    id: 3,
    name: 'Niran Boonmee',
    telephone: '062-555-0001',
    table_id: 14,
    pax: 6,
    reserve_at: dayOffset(0, 12, 0),
    state: 'arrived',
    note: '',
    customer_id: null,
    created_at: dayOffset(0, 11, 50)
  },
  {
    id: 4,
    name: 'Yuki Tanaka',
    telephone: '098-765-4321',
    table_id: 18,
    pax: 3,
    reserve_at: dayOffset(-1, 19, 30),
    state: 'arrived',
    note: 'Vegetarian menu',
    customer_id: 35,
    created_at: dayOffset(-2, 14, 0)
  },
  {
    id: 5,
    name: 'Pim Suntornkul',
    telephone: '085-222-3333',
    table_id: 12,
    pax: 5,
    reserve_at: dayOffset(-1, 20, 0),
    state: 'cancelled',
    note: 'Customer cancelled (rescheduled to next week)',
    customer_id: null,
    created_at: dayOffset(-3, 9, 20)
  },
  {
    id: 6,
    name: 'Mark Williams',
    telephone: '063-987-6543',
    table_id: null,
    pax: 2,
    reserve_at: dayOffset(0, 20, 30),
    state: 'pending',
    note: '',
    customer_id: null,
    created_at: dayOffset(0, 16, 30)
  },
  {
    id: 7,
    name: 'Kanya Phetkasem',
    telephone: '081-999-0011',
    table_id: 17,
    pax: 8,
    reserve_at: dayOffset(1, 17, 30),
    state: 'pending',
    note: 'Birthday cake at 19:00',
    customer_id: 42,
    created_at: dayOffset(0, 11, 0)
  },
  {
    id: 8,
    name: 'Daniel Lee',
    telephone: '084-321-7777',
    table_id: null,
    pax: 10,
    reserve_at: dayOffset(2, 19, 0),
    state: 'pending',
    note: 'Company dinner — corporate booking, will confirm table 1 day before',
    customer_id: 58,
    created_at: dayOffset(0, 16, 30)
  },
  {
    id: 9,
    name: 'Suda Ratanasiri',
    telephone: '081-555-7788',
    table_id: 16,
    pax: 4,
    reserve_at: dayOffset(0, 13, 0),
    state: 'pending',
    note: 'Allergy: shellfish',
    customer_id: null,
    created_at: dayOffset(0, 13, 0)
  },
  {
    id: 10,
    name: 'James Patterson',
    telephone: '091-234-9999',
    table_id: null,
    pax: 3,
    reserve_at: dayOffset(1, 12, 30),
    state: 'pending',
    note: '',
    customer_id: null,
    created_at: dayOffset(0, 15, 10)
  }
];
